module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kat Cantrell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('I', [_vm._v("USA TODAY")]), _vm._v(" bestselling author KAT CANTRELL read her first Harlequin novel in third grade and has been scribbling in notebooks since she learned to spell. She's a former Harlequin So You Think You Can Write winner and former RWA Golden Heart finalist. Kat, her husband and their two boys live in north Texas.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/I2z1J0/tc-custom/9781488011733.jpg?1738386796968",
      "alt": "This image is the cover for the book Best Friend Bride, In Name Only"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Best Friend Bride, In Name Only\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A billionaire bachelor’s marriage of convenience goes from all business to pure pleasure in the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author’s romance.")]), _c('br'), _c('br'), _vm._v("Billionaire Jonas Kim is desperate to become CEO of his family’s company. But to satisfy his strict Korean grandfather, he needs a smoothly executed business merger. And to get "), _c('i', [_vm._v("that")]), _vm._v(", he needs a smoothly executed marriage of convenience. Enter Viviana Dawson, Jonas’s best friend, who agrees to become a contract bride until the deal is sealed."), _c('br'), _c('br'), _vm._v("Viv has crushed on Jonas forever, but the stubborn tycoon can’t see over the fortress he’s constructed around his heart. Yet when fake marital bliss leads to unparalleled bedroom ecstasy, Viv declares war on the love-shy bachelor—and she won’t settle for anything less than surrender!\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0